<template>
  <div>
    <div class="hero-banner-six">
      <div class="illustration-content">
        <img
          src="../../assets/images/shape/144.svg"
          alt=""
          class="main-img ms-auto"
        />
        <img
          src="../../assets/images/niku/niku_wide_trans.png"
          alt=""
          class="screen-one"
        />
        <div class="screen-two">
          <img
            src="../../assets/images/niku/niku_vert_trans.png"
            alt=""
            class="ms-auto"
          />
        </div>
        <img
          src="../../assets/images/shape/145.svg"
          alt=""
          class="shapes shape-one"
        />
        <img
          src="../../assets/images/shape/146.svg"
          alt=""
          class="shapes shape-two"
        />
        <img
          src="../../assets/images/shape/147.svg"
          alt=""
          class="shapes shape-three"
        />
        <img
          src="../../assets/images/shape/148.svg"
          alt=""
          class="shapes shape-four"
        />
        <img
          src="../../assets/images/shape/149.svg"
          alt=""
          class="shapes shape-five"
        />
        <img
          src="../../assets/images/shape/150.png"
          alt=""
          class="shapes shape-six"
        />
        <div class="shapes oval-one"></div>
        <div class="shapes oval-two"></div>
        <div class="shapes oval-three"></div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-xl-6 col-lg-6">
            <h1 class="font-recoleta hero-heading">
              You dream it. She <span>draws</span> it.
            </h1>
            <p class="hero-sub-heading">
              NikuNiku900 turns your prompts into art!
            </p>
            <div class="d-sm-flex align-items-center button-group">
              <!-- <button
                data-bs-toggle="modal"
                data-bs-target="#videoModal"
                class="d-flex align-items-center video-button fancybox order-sm-last"
              >
                <img
                  src="../../assets/images/icon/play-circle.svg"
                  alt=""
                  class="icon"
                />
                <span>See Intro Video</span>
              </button> -->
              <a
                href="https://discord.com/invite/mzQYk4BfgF"
                class="d-flex align-items-center ios-button gr-bg-one hover-reverse-gr-bg-one order-sm-first"
              >
                <img
                  src="../../assets/images/icon/discord.svg"
                  alt=""
                  class="icon"
                  width="40px"
                />
                <div>
                  <span>Join us on</span>
                  <strong>Discord</strong>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- VideoModal -->
    <!-- <VideoModal videoId="aXFSJTjVjw0" /> -->
  </div>
</template>

<script>
// import VideoModal from "../common/Modal/VideoModal.vue";

export default {
  name: "HeroArea",
  components: {
    // VideoModal,
  },
};
</script>
